import React from 'react';
import { GetRegion } from '../../constants';
import { converter } from '../../helpers/converter';
import ContentWrapper from '../promos/ContentWrapper';
import ContentTitle from '../promos/ContentTitle';
import ContentText from '../promos/ContentText';
import { useNavigate } from 'react-router-dom';

const IpTelmexRegisterForm = ({
  isValidForm = false,
  submitted = false,
  loading = false,
  termsValue = 1,
  termsError = '',
  handleSubmit = () => {},
  translations = {},
  info = {},
  origin = '',
}) => {
  const navigate = useNavigate();
  return (
    <ContentWrapper>
      <ContentTitle>
        {converter.convertApaUnicode(
          translations,
          'ip_telmex_title',
          '¡Felicidades!',
        )}
      </ContentTitle>

      <ContentText extraClassName="big">
        <span
          dangerouslySetInnerHTML={{
            __html: converter.convertApaUnicode(
              translations,
              'ip_telmex_description',
              'Con <strong>Infinitum</strong> ya tienes Claro video sin costo adicional. Disfruta de cientos de películas y series, además puedes rentar o comprar estrenos o suscribirte a nuestros canales Premium de HBO y FOX',
            ),
          }}
        />
      </ContentText>

      <form
        className="md-pr-20 md-pl-20"
        onSubmit={e => (e.preventDefault(), handleSubmit())}
        noValidate
      >
        <div className="row">
          <div className="col-sm-10 col-sm-offset-1 xs-mt-20 xs-mb-20">
            <img
              className={`center-block xs-mt-20 xs-mb-20 ${
                !loading ? 'hidden' : ''
              }`}
              src="/webclient/sk_core/images/cargando.gif"
              width="54"
            />
            <button
              className={`btn btn-block btn-promo ${
                loading || !isValidForm ? 'unactive' : ''
              }`}
              type="submit"
            >
              {converter.convertApaUnicode(
                translations,
                'ip_telmex_activate_button',
                'Activalo Ahora',
              )}
            </button>
          </div>
        </div>

        <ContentText extraClassName="small">
          <a href="/terminos_y_condiciones" target="_blank">
            {`Al continuar aceptas los ${converter.convertApaUnicode(
              translations,
              'tyc_text',
              'Términos y condiciones',
            )} ${converter.convertApaUnicode(
              translations,
              'sso_acceptance_tycs2',
              'del servicio',
            )}`}
          </a>
        </ContentText>
      </form>

      <ContentText>
        {converter.convertApaUnicode(
          translations,
          'ip_telmex_login_label',
          '¿Ya tienes una cuenta?',
        )}
      </ContentText>

      <ContentText>
        <a
          href={`/${GetRegion()}/user?login`}
          onClick={e => (
            e.preventDefault(), navigate(`/${GetRegion()}/user?login`)
          )}
        >
          {converter.convertApaUnicode(
            translations,
            'ip_telmex_login_link',
            'INICIA SESIÓN',
          )}
        </a>
      </ContentText>
    </ContentWrapper>
  );
};

export default IpTelmexRegisterForm;
